import { gql } from '@apollo/client'

export const DELETE_AUDITS = gql`
  mutation AdminDeleteAudits($input: BulkDeleteInput!) {
    deleteAudits(input: $input) {
      deleted
    }
  }
`
